import * as React from "react";
import PopDetail from "../../popdetail";
import Wait from "../../wait";
import CreateService from "../../../service/create";

export default class PaneAddSignatory extends React.Component{
    constructor(props) {
        super(props);
        this.handleChanges = this.handleChanges.bind(this)
        this.submit = this.submit.bind(this)
        this.handleChangeFile = this.handleChangeFile.bind(this)
    }

    handleChanges= e =>{this.setState({[e.target.name]: e.target.value})}
    handleChangeFile=e=>{this.setState({ [e.target.name]:e.target.files[0] })}

    render() {
        return(<div style={{height:'100%'}} className={'col col-12'}>
            <br/>
            <div className={'row'}>
                <div className={'col col-sm-12'}>

                    <h2>{this.props.signatory.designation.name} - {this.props.signatory.locality.name}</h2>
                    <table style={{width:'100%'}}>
                        <tbody>

                        <tr  className={'label'}>
                            <td>First Name</td>
                            <td>Middle Name</td>
                            <td>Last Name</td>
                        </tr>
                        <tr>
                            <td>
                                <input type={'text'} style={{width: '98%'}} name={'first_name'}
                                       onChange={this.handleChanges}/>
                            </td>
                            <td>
                                <input type={'text'} style={{width: '98%'}} name={'middle_name'}
                                       onChange={this.handleChanges}/>
                            </td>
                            <td>
                                <input type={'text'} style={{width: '98%'}} name={'last_name'}
                                       onChange={this.handleChanges}/>
                            </td>
                        </tr>

                        <tr className={'label'}>
                            <td><span>Phone Number</span></td>
                            <td><span>Signature</span></td>
                        </tr>
                        <tr>
                            <td><input style={{width:'98%'}} name={'phone'}  onChange={this.handleChanges}/></td>

                            <td colSpan={2}>
                                <input type={'file'} accept={".png,.PNG"}
                                       name={'sign'} onChange={this.handleChangeFile}/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <hr/>
            <div style={{width:'100%'}}>
                <button className={'btn submit'} style={{width:'100px'}} onClick={this.submit}>
                    <span className={'fa fa-save'}/>Save
                </button>
                <button className={'btn error'} style={{width:'100px'}} onClick={PopDetail.dismiss}>
                    <span className={'fa fa-times'}/>Close
                </button>
            </div>
        </div>)
    }



    submit(){

        try {

            let firstname = this.state.first_name
            let middlename = this.state.middle_name
            let lastname = this.state.last_name


            if (firstname===undefined||firstname===null || lastname===undefined || lastname===null){
                alert('First name and Last name must be Filled !!! ')
                return
            }



            if (this.state.sign===''||this.state.sign===undefined||this.state.sign===null){
                alert('Invalid Signature')
                return
            }

            let extra = {
                firstname:firstname,
                middlename:middlename,
                lastname:lastname,
                phone:this.state.phone,
                project_id:this.props.project.id,
                locality_id:this.props.signatory.locality.id,
                designation_id:this.props.signatory.designation.id,
                task_id: this.props.taskId,
                screen_code: this.props.screen_code
            }

            console.log(extra)

            const formData = new FormData()
            formData.append('signature',this.state.sign)

            formData.append('extra',JSON.stringify(extra))

            Wait.show("Saving...")
            CreateService.createSignatory(formData).then(d=>{
                Wait.dismiss()
                try {
                    PopDetail.dismiss()
                    this.props.loadData()
                }catch (e) {
                    console.log(e)
                }
                //
            })
        }catch (e){
            console.log(e)
        }
    }
}